<template>
    <div class="notice">
        <page-head></page-head>
        <div class="middle_content">
            <div class="notice_title">申请须知</div>
            <!-- v-html="siteContent" -->
            <div class="notice_content">
                <div v-html="siteContent" ></div>
                <!-- <quill-editor @focus="focus($event)" class="ql-editor" v-model="siteContent"> -->
                <!-- </quill-editor> -->
            </div>
        </div>
        <div class="footer">
            <div>请使用谷歌、edge，或其他三方浏览器（360、搜狗等浏览器）的高速模式访问本系统</div>
            <div>四川大学继续教育学院</div>
        </div>
    </div>
</template>
<script>
import PageHead from '@/components/PageHead.vue'
import { querySchoolbranchNotice } from '@/request/application'
export default {
    components: {
        PageHead
    },
    data() {
        return {
            siteContent: ''
        }

    },
    methods: {
        //获取焦点事件
        focus(event) {
            event.enable(false);  //设置富文本编辑器不可编辑
        }
    },
    created() {
        querySchoolbranchNotice().then(res => {
            if (res.success) {
                this.siteContent = res.result[0].content;
            }
        })
    }
}
</script>
<style lang="less" scoped>
.notice {
    box-sizing: border-box;
    position: relative;
    padding-bottom: 100px;
    min-height: 100%;
    height: auto;
     .notice_title{
        text-align: center;
        font-size: 20px;
        width: 100%;
        margin-bottom: 30px;
        font-weight: bold;
     }
    .middle_content  {
        width: 100%;
        padding: 30px 0 30px 0;
        // height: calc(~"100% - 200px");
        // min-height: 600px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // flex-wrap: wrap;

        .notice_content div {
            width: 800px;
            margin: auto;
            min-height: 400px;
            // max-height: 500px;
            // overflow: auto;
            padding: 20px;
            box-sizing: border-box;
            border: 2px dashed #ccc;
        }

    }

    .footer {
        width: 100%;
        height: 100px;
        background: #ECECEC;
        text-align: center;
        position: absolute;
        left: 0;
        bottom: 0;

        div:first-child {
            padding: 26px 0 22px 0;
        }

        div {
            color: #333;
            font-size: 18px;
            line-height: 1;
        }
    }
}</style>